/**
 * The toast hook lives apart from the provider component so the provider
 * file only exports components — which is what keeps fast refresh working.
 */
import { createContext, useContext } from "react";

export type ToastKind = "info" | "success" | "error";

export interface ToastValue {
  show: (message: string, kind?: ToastKind) => void;
}

export const ToastContext = createContext<ToastValue>({ show: () => {} });

export function useToast(): ToastValue {
  return useContext(ToastContext);
}
